import { ICheckboxProps } from "interfaces";
import { useEffect, useState } from "react";

const CheckBox = ({ label, onChange, defaultValue = false, labelClassName }: ICheckboxProps) => {
    const [isChecked, setIsChecked] = useState<boolean>(defaultValue);

    useEffect(() => setIsChecked(defaultValue), [defaultValue]);

    const handleChangeCheckbox = (event: any) => {
        setIsChecked(event.target.checked);
        onChange(event.target.checked);
    };

    return (
        <label className="pl-container-checkbox">
            <span className={`pl-text-[14px] pl-font-medium pl-mr-8 pl-cursor-pointer ${labelClassName}`}>{label}</span>
            <input type="checkbox" className="pl-cursor-pointer" checked={isChecked} onChange={handleChangeCheckbox} />
            <span className={`pl-checkmark pl-cursor-pointer ${isChecked && `pl-bg-main-light pl-border-none`}`} />
        </label>
    );
};

export default CheckBox;
